import { ReactComponent as Cloud } from "../../../Assets/img/Kyc/svg/Cloud.svg";
import React, { useEffect, useState } from "react";
import { pdfjs } from "react-pdf";
import Flag from "../../../Assets/img/Kyc/Flag1.jpg";
import Lion from "../../../Assets/img/Kyc/Lion.png";
import { Button, CircularProgress, Grid, IconButton, InputAdornment, Modal, TextField } from "@mui/material";
import digi from "../../../Assets/img/Kyc/digi2.jpg";
import VerifyPANCardSkeleton from "../../LoadingSkeleton/VerifyPANCardSkeleton";
import VerifyPANCardSkeleton2 from "../../LoadingSkeleton/VerifyPANCardSkeleton2";
import axios from "axios";
import { useQuantityContext } from "../../QuantityContext";
import { FreehandCropper } from "../../Utilities/Croppers";
import DigilockerButton from "./DigilockerButton";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { ReactComponent as VerifiedTick } from "../../../Assets/img/icons/verified-tick.svg";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { clearDigilockerData, getKycOcrApiReducer, patchKycPanOcrApiReducer, postKycOcrApiReducer } from "../../../Redux/Reducers/KycReducer";
import { ReactComponent as EditIcon } from "../../../Assets/img/icons/edit-icon-figma.svg";
import { patchOnboardingReducer } from "../../../Redux/Reducers/OnboardingReducer";
import { MdDelete } from "react-icons/md";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const VerifyPANCard = () => {
  const [isDragging, setIsDragging] = useState(false);
  const [previewData, setPreviewData] = useState({ front: null, });
  const [isVerified, setIsVerified] = useState(false);
  const [isUploaded, setIsUploaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [apiResponse, setApiResponse] = useState({ front: null });
  const [selectedBgImage, setSelectedBgImage] = useState(null);
  const [selectedBgFile, setSelectedBgFile] = useState(null);
  const [openRectCropper, setOpenRectCropper] = useState(false);
  const [currentSide, setCurrentSide] = useState("");
  const [ocrResponse, setOcrResponse] = useState(null);
  const { openSnackbar, handleSuccess, handleFailure, handleInfo } = useQuantityContext();
  const [userData, setUserData] = useState({})
  const [digilocker, setDigilocker] = useState({
    digilockerid: '',
    reference_key: ''
  });

  // console.log("userData123456", userData)
  // console.log("digilocker123456", digilocker)
  // console.log("IAMPAN--DigiLocker", digilocker, apiResponse)
  const [finalVerifieddata, setFinalVerifieddata] = useState({});

  const GetData = useSelector((state) => state?.Kyc?.verifiedGetData?.data?.panData);
  const AdharGetData = useSelector((state) => state?.Kyc?.verifiedGetData?.data?.aadharData);
  const DlGetData = useSelector((state) => state?.Kyc?.verifiedGetData?.data?.dlData);
  const digilockerData = useSelector((state) => state?.Kyc?.digilockerDataCode);

  // console.log("digilockerData5555", digilockerData)

  const [verifyStatus, setVerifiyStatus] = useState({
    aadhaar: false,
    pan: false,
    dl: false,
  });





  useEffect(() => {
    const getUrl = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/digilocker/url`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("objectId")}`,
              // "ngrok-skip-browser-warning": "69420"
            },
          }
        );
        const data = response;
        // console.log("Locker data digi", response);

        if (response?.data?.statusCode === 1000) {
          // setKycCompleted(true);
          // setDisable(true);

          setIsLoading(false);

          // onKycComplete(response?.data?.data?.verified[doc]);
          setUserData(response?.data?.data?.verified["pan"]);
          return;
        } else if (response?.data?.statusCode === 200) {
          setIsLoading(false);
          // onKycComplete(response?.data?.data?.verified[doc]);
          setUserData(response?.data?.data?.verified["pan"]);
          // setUrl(response?.data?.data?.url);
          // setVerified(response?.data?.data?.verified[doc] !== null);
        }
      } catch (error) {
        openSnackbar("Error in Digilocker URL", "error");
      }
    };

    if ((GetData !== "Not verified Yet" || GetData !== null || GetData !== undefined)) {

      getUrl();
    }
  }, [GetData])

  useEffect(() => {
    const isVerified = (value) =>
      value !== "Not verified Yet" && value !== undefined && value !== null;

    setVerifiyStatus({
      aadhaar: isVerified(AdharGetData),
      pan: isVerified(GetData),
      dl: isVerified(DlGetData),
    });
   
    
  }, [AdharGetData, GetData, DlGetData]);

  // console.log("verifyStatus:", verifyStatus);

  const [formData, setFormData] = useState({
    name: '',
    dob: '',
    fatherName: '',
    pan: '',
    gender: '',

  });
  const dispatch = useDispatch();
  const [close, setClose] = useState(false);

  const handleKycCompletion = (data) => {
    setUserData(data);
    setIsVerified(true);
  };


  useEffect(() => {
    if (GetData !== "Not verified Yet") {

      setFormData({
        name: GetData?.name || '',
        dob: GetData?.dob || '',
        fatherName: GetData?.co || '',
        // aadhaar: GetData?.aadhaar_number || '',
        gender: GetData?.gender || '',

      });
    } else {
      setFormData({
        name: ocrResponse?.name || '',
        dob: ocrResponse?.dob || '',
        fatherName: ocrResponse?.father_name || '',
        pan: ocrResponse?.pan_number || '',
        gender: ocrResponse?.gender || '',

      });
    }
  }, [ocrResponse]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };


  useEffect(() => {
    if (apiResponse.front) {
      triggerOcr(apiResponse);
    }
  }, [apiResponse]);


  const handleupdate = async () => {
    try {
      // console.log("FOrmData", formData);
      const dateStr = formData?.dob;
      const year = dateStr.split("-")[2];
      // console.log(year);

      const data = {
        "name": formData?.name,
        "father_name": formData?.fatherName,
        "dob": formData?.dob,
        "yob": year,
        "gender": formData?.gender,

      };


      const response = await dispatch(patchKycPanOcrApiReducer(data));
      // console.log("REsponse Data", response);
      if (response?.payload?.statusCode === 200) {
        setClose(false);
        const data = {
          "aadharVerified": verifyStatus?.aadhaar,
          "panVerified": true,
          "dlVerified": verifyStatus?.dl,
          // "digilockerid": userData?.pan_number ? digilockerData?.digilockerid : digilocker?.digilockerid,
          // "reference_key": userData?.pan_number ? digilockerData?.reference_key : digilocker?.reference_key,
          "digilockerid":   digilockerData?.digilockerid != "" ?  digilockerData?.digilockerid :   digilocker?.digilockerid,
          "reference_key": digilockerData?.reference_key != "" ? digilockerData?.reference_key :   digilocker?.reference_key,
        }
        const Postresponse = await dispatch(postKycOcrApiReducer(data));
        // console.log("postKycOcrApiReducer postKycOcrApiReducer", Postresponse);
        if (Postresponse?.payload?.message?.message === "DigilockerID & ReferrenceKey is necessary for the verification") {
          handleInfo("DigiLocker verification is required to proceed.")
        }
        const kycresponse = await dispatch(getKycOcrApiReducer());
        // console.log("getKycOcrApiReducergetKycOcrApiReducer", kycresponse);

        if (kycresponse?.payload?.statusCode === 200) {
          setFinalVerifieddata(kycresponse?.payload?.data?.panData);
          const panData = kycresponse?.payload?.data?.panData;
          const fullName = panData?.name || '';
          const nameParts = fullName.trim().split(' ');

          const payload = {
            first_name: nameParts.slice(0, -1).join(' '), // All except the last word
            last_name: nameParts.slice(-1)[0] || '',
            dob: panData?.dob || null,
            gender: panData?.gender === "F" || "FEMALE" ? "female" : "male" || null,
            address: `${panData?.postalCode || ''} ${panData?.locality || ''} ${panData?.vtc || ''} ${panData?.street || ''} ${panData?.city || ''} ${panData?.district || ''} ${panData?.state || ''}`.trim()
          };
          // console.log("Payload", payload);

          const patchResponse = await dispatch(patchOnboardingReducer(payload));
          await dispatch(clearDigilockerData()) 
        }
      }
    } catch (error) {
      console.log("API ERROR", error);
    }
  };

  // fetch image and display apiResponse if available else display skeleton
  const fetchImage = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/ocr/images`, {
        headers: {
          "x-api-key": process.env.REACT_APP_API_KEY,
          Authorization: `Bearer ${localStorage.getItem('objectId')}`,
          // "ngrok-skip-browser-warning": "69420"
        },
      });
      const front = response.data.data.filter((img) => img.document_type === "PAN_Front")[0].blob_url;

      triggerOcr({ front });
      setPreviewData({ front });
      setIsUploaded(true);
      setOcrResponse({ ...ocrResponse, statusCode: 200 });
      setIsVerified(true);
    } catch (error) {
      console.error("Error fetching Pan details:", error.message);
    }
  };

  useEffect(() => {
    fetchImage();
  }, []);

  useEffect(() => {
    const navurl = new URL(window.location.href);
    const code = navurl.searchParams.get("code");
    const state = navurl.searchParams.get("state");
    if (code && state) {
      setIsUploaded(true);
      setIsLoading(false);
      setOcrResponse({ ...ocrResponse, statusCode: 200 });
      setIsVerified(true);
    }
  }, [])

  const handleBlobUpload = async (base64Data, side) => {
    // console.log("base64Database64Data", base64Data);
    try {
      // const byteString = atob(base64Data.split(",")[1]);
      // const mimeString = base64Data.split(",")[0].split(":")[1].split(";")[0];
      // const arrayBuffer = new ArrayBuffer(byteString.length);
      // const uintArray = new Uint8Array(arrayBuffer);

      // for (let i = 0; i < byteString.length; i++) {
      //   uintArray[i] = byteString.charCodeAt(i);
      // }

      // const blob = new Blob([arrayBuffer], { type: mimeString });

      // const formData = new FormData();
      // formData.append("file", blob, `${side}.jpeg`);

      // const response = await axios.post(
      //   `${process.env.REACT_APP_BACKEND_URL}/uploadpublicblob/generate-sas-url`,
      //   formData,
      //   { headers: { "Content-Type": "multipart/form-data" } }
      // );

      // const sasUrl = response.data.url;
      setApiResponse((prev) => {
        const updatedResponse = { ...prev, [side]: base64Data };

        // Check if both "front" and "back" URLs are available
        if (updatedResponse.front && updatedResponse.back) {
          // triggerOcr(updatedResponse); // Call the OCR API
        }

        return updatedResponse;
      });
    } catch (error) {
      console.error("Error uploading file:", error.message);
      // alert("Error uploading file. Please check the console for details.");
      handleFailure(error.message);
    }
  };

  const triggerOcr = async (apiResponse) => {
    try {
      const viewerToken = localStorage.getItem('objectId')?.trim(); // Retrieve token from localStorage
      const apiKey = process.env.REACT_APP_API_KEY; // Get API key from environment variable

      const headers = {
        'x-api-key': apiKey,
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${viewerToken}`,
        // "ngrok-skip-browser-warning": "69420" // Add the token as Bearer
      };

      // const payload = {
      //   front: apiResponse.front,
      // };

      // console.log("OCR Payload:", apiResponse);
      const formData = new FormData();
      if (apiResponse.front) {
        try {
          const response = await fetch(apiResponse.front);  // Fetch blob
          const blob = await response.blob();             // Convert to blob
          // const file = new File([blob], attachment.name, { type: attachment.type }); // Create File object

          formData.append("front_side", blob);  // Append as binary file

        } catch (error) {
          console.error("Error converting blob to file:", error);
        }
      }


      const response = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/ocr/pan`, formData, { headers });
      // console.log("OCR Response:", response.data);
      // return;
      // Store the response in state
      setOcrResponse(response?.data?.data);
      setIsUploaded(true);
      setIsLoading(false);
      handleSuccess("Upload successful!")
    } catch (error) {
      console.error("Error during OCR API call:", error.response?.data || error.message);
      // alert(error.response?.data?.message || "Error processing pan details.");
      handleFailure(error.response?.data?.message);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleUpload = async () => {
    if (!previewData.front) {

      handleFailure("Please uploaded before proceeding.")
      return;
    }

    setIsLoading(true);

    try {
      // Upload both images
      await handleBlobUpload(previewData.front, "front");

    } catch (error) {
      setIsLoading(false);
      console.error("Error during upload:", error);
    }
  };




  const handleDragLeave = () => setIsDragging(false);

  const handleFileDrop = (e, side) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    handleFileChange(file, side);
  };

  const handleFileChange = (file, side) => {
    if (!file) return;

    if (file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setSelectedBgImage(event.target.result);
        setSelectedBgFile(file);
        setCurrentSide(side);
        setOpenRectCropper(true);
      };
      reader.readAsDataURL(file);
    } else if (file.type === "application/pdf") {
      const reader = new FileReader();
      reader.onloadend = () => renderPdfToImage(reader.result, side);
      reader.readAsArrayBuffer(file);
    } else {
      console.error("Unsupported file type");
    }
  };

  const resizeImage = (imageFile, width) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        const scaleFactor = width / img.width;
        canvas.width = width;
        canvas.height = img.height * scaleFactor;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL("image/jpeg"));
      };
      img.src = URL.createObjectURL(imageFile);
    });
  }


  const handleSaveBgImage = async (croppedFile, side) => {
    // const resizedImageBase64 = await resizeImage(croppedFile, 512);
    const file = URL.createObjectURL(croppedFile);
    setPreviewData((prev) => ({ ...prev, [side]: file }));
    handleRectCropperClose();
  }

  const renderPdfToImage = (pdfData, side) => {
    pdfjs.getDocument({ data: pdfData }).promise.then((pdf) => {
      pdf.getPage(1).then((page) => {
        const viewport = page.getViewport({ scale: 1 });
        const canvas = document.createElement("canvas");
        const canvasContext = canvas.getContext("2d");
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        page.render({ canvasContext, viewport }).promise.then(() => {
          const resizedImageBase64 = resizeCanvasToWidth(canvas, 512);  // Resize image to 512px width
          setSelectedBgImage(resizedImageBase64);  // Set the image for cropping
          setSelectedBgFile(pdfData);  // Store the PDF data for potential use
          setCurrentSide(side);  // Set the current side for saving (front or back)
          setOpenRectCropper(true);  // Open the cropper dialog
        });
      });
    });
  };

  const resizeCanvasToWidth = (canvas, targetWidth) => {
    const targetHeight = (targetWidth / canvas.width) * canvas.height;
    const resizedCanvas = document.createElement("canvas");
    const resizedContext = resizedCanvas.getContext("2d");

    resizedCanvas.width = targetWidth;
    resizedCanvas.height = targetHeight;

    resizedContext.drawImage(canvas, 0, 0, targetWidth, targetHeight);

    return resizedCanvas.toDataURL("image/jpeg"); // Return the resized image as base64
  };

  const handleRectCropperClose = () => {
    setOpenRectCropper(false);
    setSelectedBgFile(null);
    setSelectedBgImage(null);
  };



  const handleVerify = () => setIsVerified(true);

  const ocrFields = [
    { label: "PAN Number", value: ocrResponse?.pan_number || "NA" },
    { label: "Name", value: ocrResponse?.name || "NA" },
    { label: "Father's Name", value: ocrResponse?.father_name || "NA" },
    { label: "Date of Birth", value: ocrResponse?.dob || "NA" },
    {
      label: "Gender",
      value:
        ocrResponse?.gender === "M" ? "Male" :
          ocrResponse?.gender === "F" ? "Female" :
            ocrResponse?.gender === "O" ? "Others" :
              "NA"
    },
  ];

  const VerifiedFields = [
    { label: "PAN Number", value: GetData?.pan_number || "NA" },
    { label: "Name", value: GetData?.name || "NA" },
    { label: "Father's Name", value: GetData?.father_name || "NA" },
    { label: "Date of Birth", value: GetData?.dob || "NA" },
    {
      label: "Gender",
      value:
        GetData?.gender === "MALE" ? "Male" :
          GetData?.gender === "FEMALE" ? "Female" :
            GetData?.gender === "O" ? "Others" :
              "NA"
    },
  ];


  const Digilockerdata = {
    name: userData?.name,
    dob: userData?.dob,
    fatherName: userData?.co,
    gender: userData?.gender,

  };
  // console.log("DigilockerdataDigilockerdata", Digilockerdata);
  // console.log("ocrFieldsocrFields", ocrResponse, "ocrFieldsocrFields LENGTH", ocrFields?.length, "userDatauserData", userData, "digilocker", digilocker);
  // Helper function to check if any field has data
  const hasAnyData = () => {
    return (
      ocrResponse?.pan_number || GetData?.pan_number || userData?.pan_number ||
      ocrResponse?.name || GetData?.name || Digilockerdata?.name ||
      ocrResponse?.dob || GetData?.dob || Digilockerdata?.dob ||
      ocrResponse?.father_name || GetData?.father_name || Digilockerdata?.fatherName ||
      ocrResponse?.gender || GetData?.gender || Digilockerdata?.gender
    );
  };

  // Helper function to get mismatch count
  const getMismatchCount = () => {
    let count = 0;

    if (Digilockerdata?.name && formData.name && formData.name !== Digilockerdata.name) count++;
    if (Digilockerdata?.dob && formData.dob && formData.dob !== Digilockerdata.dob) count++;
    if (Digilockerdata?.fatherName && formData.fatherName && formData.fatherName !== Digilockerdata.fatherName) count++;
    if (Digilockerdata?.gender && formData.gender && formData.gender !== Digilockerdata.gender) count++;

    return count;
  };

  // Helper function to format gender
  const formatGender = (gender) => {
    if (!gender) return 'NA';
    if (gender === 'M' || gender === 'MALE') return 'Male';
    if (gender === 'F' || gender === 'FEMALE') return 'Female';
    if (gender === 'O' || gender === 'OTHERS') return 'Others';
    return gender;
  };

  return (
    <div className="Main-Container-kyc">
      <div className="rounded-2 bg-white p-2">
        <div className="d-flex flex-column text-center m-3">
          <h2 className="text-center">Verify Your PAN Card</h2>
          <p className="text-center">Upload Your PAN Card for Secure Verification.</p>

          <div className="d-flex flex-row justify-content-evenly mt-3">
            <div className="imagePreviewContainer-pan2">
              {!previewData.front ? (
                <VerifyPANCardSkeleton />
              ) : (
                <div
                  style={{
                    position: 'relative',
                    display: 'inline-block',
                    marginBottom: '10px'
                  }}
                  onMouseEnter={e => {
                    const overlay = e.currentTarget.querySelector('.delete-overlay-front');
                    if (overlay) overlay.style.opacity = '1';
                  }}
                  onMouseLeave={e => {
                    const overlay = e.currentTarget.querySelector('.delete-overlay-front');
                    if (overlay) overlay.style.opacity = '0';
                  }}
                >
                  <img
                    src={previewData.front}
                    alt="PAN Preview"
                    style={{
                      maxWidth: "300px",
                      boxShadow: "rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px",
                      border: "1px dashed gray",
                      padding: "3px",
                      display: 'block'
                    }}
                  />
                  <div
                    className="delete-overlay-front"
                    onClick={!verifyStatus?.pan ? () => {
                      setPreviewData(prev => ({ ...prev, front: null }));
                      setApiResponse(prev => ({ ...prev, front: null }));
                      setOcrResponse(null);
                      setIsUploaded(false);
                      setIsVerified(false);
                    } : undefined}
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      backgroundColor: 'rgba(0, 0, 0, 0.5)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      opacity: 0,
                      transition: 'opacity 0.2s ease-in-out',
                      cursor: verifyStatus?.pan ? 'not-allowed' : 'pointer',
                      zIndex: 10
                    }}
                  >
                    {!verifyStatus?.pan ? <MdDelete style={{ fontSize: '48px', color: '#ff0000' }} /> : ""}
                  </div>
                </div>
              )}
            </div>

            <div className="uploadContainer" >

              {!previewData?.front ? <div className="uploadContainer-card">
                <div
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}
                  onDrop={(e) => handleFileDrop(e, "front")}
                  className="uploadZone">
                  <input type="file" accept="image/*, application/pdf" style={{ display: "none" }} onChange={(e) => handleFileChange(e.target.files[0], "front")} id="file-input-front" />
                  <label htmlFor="file-input-front" className="uploadLabel">
                    <Cloud width={80} />
                    <span className="m-0 p-0">
                      {isDragging ? " Drop front file here" : " Drag front card here or"}
                      <span className="text-primary"> Upload File</span>
                    </span>
                    <p>1MB max file size</p>
                  </label>
                </div>

              </div> : null}



              <div style={{ display: "flex", flexDirection: "column", gap: "5px" }}>
                {((GetData === "Not verified Yet" || GetData === null || GetData === undefined) && (previewData.front)) && (

                  isLoading ? (
                    <CircularProgress size={40} />
                  ) : (
                    <Button variant="contained" className="btncolor" onClick={handleUpload}>Upload</Button>
                  ))}
                <div style={{ marginTop: "20px" }}>
                  {previewData.front && !ocrResponse?.name && (
                    <p className="text-xs text-amber-600 mt-2 text-center" style={{ fontSize: "14px", color: "#ff9800", textAlign: "center" }}>
                      PanCard uploaded. Click on "upload" to verify the pan.
                    </p>
                  )}
                </div>

                {/* {(ocrResponse && (GetData === "Not verified Yet" || GetData === null || GetData === undefined)) ? (
                  <DigilockerButton doc={"pan"} onKycComplete={handleKycCompletion} setDigilocker={setDigilocker} />
                ) : ""}       */}
                {ocrResponse && !digilockerData?.digilockerid !=="" &&
                  (GetData === "Not verified Yet" || !GetData) && (
                    <DigilockerButton
                      doc={"pan"}
                      onKycComplete={handleKycCompletion}
                      setDigilocker={setDigilocker}
                    />
                  )}

                {(GetData !== "Not verified Yet" && GetData !== null && GetData !== undefined) && <h3 className="fw-semibold">KYC Verification Completed</h3>}
              </div>

              {!userData?.pan_number && !verifyStatus?.pan && <div style={{ marginTop: "20px" }}>
                {ocrResponse && (
                  <p className="text-xs text-amber-600 mt-2 text-center" style={{ fontSize: "14px", color: "#ff9800", textAlign: "center" }}>
                    'Pan Card uploaded. Click "Verify with Digilocker" to complete verification.'

                  </p>
                )}
              </div>}

              {userData?.pan_number && !verifyStatus?.pan && (
                <div style={{ marginTop: "20px" }}>
                  {ocrResponse && (
                    <p
                      className="text-xs text-amber-600 mt-2 text-center"
                      style={{
                        fontSize: "14px",
                        color: "#ff9800",
                        textAlign: "center",
                      }}
                    >
                      Click on Verify icon to make the corrections and save
                    </p>
                  )}
                </div>
              )}


              <div style={{ display: "flex", justifyContent: "space-around", gap: "5px", padding: "15px", borderRadius: "8px" }}>
                <div style={{ border: "1px solid gray", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", }}>
                  {(GetData !== "Not verified Yet" && GetData !== null && GetData !== undefined) ? (
                    <div style={{ width: "100%", padding: "10px" }}>
                      <div className="d-flex flex-row justify-content-between align-items-center">

                        <h5 className="fw-semibold">Verified Data</h5>
                        <div className="flex-center mb-1" >
                          {/* <IconButton onClick={() => setClose(true)}>
                            <EditIcon />
                          </IconButton>
                          <div
                          >
                            Edit
                          </div> */}

                          <VerifiedTick className={isVerified ? "green-verified-tick" : ""} />
                        </div>
                      </div>
                      <table className="mytable">
                        <tr>
                          <th className="mytable">Field</th>
                          <th className="mytable">Data</th>
                        </tr>
                        {VerifiedFields.map((field, index) => (
                          <tr key={index}>
                            <td className="mytable"> {field.label}</td>
                            <td className="mytable" style={{ borderWidth: "1" }}>{field.value || "NA"}</td>
                          </tr>
                        ))}
                      </table>
                    </div>
                  ) : (!ocrResponse || ocrFields.every(field => !field.value || field.value === "NA")) ? (
                    ""
                  ) : (
                    <div style={{ width: "100%", padding: "10px" }}>
                      <div className="d-flex flex-row justify-content-between align-items-center">

                        <h5 className="fw-semibold">Data from OCR</h5>
                        <div className="flex-center mb-1" onClick={() => setClose(true)} >
                          <IconButton >
                            <VerifiedTick />
                          </IconButton>
                          <div
                          >
                            Verify
                          </div>


                        </div>
                      </div>
                      <table className="mytable">
                        <tr>
                          <th className="mytable">Field</th>
                          <th className="mytable">Data</th>
                        </tr>
                        {ocrFields?.map((field, index) => (
                          <tr key={index}>
                            <td className="mytable"> {field.label}</td>
                            <td className="mytable" style={{ borderWidth: "1" }}>{field.value || "NA"}</td>
                          </tr>
                        ))}
                      </table>
                    </div>
                  )}
                </div>

                {userData?.pan_number && ocrResponse  && (
                  <div style={{ width: "100%", padding: "10px", border: "1px solid gray" }}>
                    <h5 className="fw-semibold">Data From Digilocker</h5>
                    <table className="mytable">
                      <tr>
                        <th className="mytable">Field</th>
                        <th className="mytable">Data</th>
                      </tr>
                      {userData && Object.keys(userData).map((field, index) => (
                        field !== 'photo' && (
                          <tr key={index}>
                            <td className="mytable"> {field.charAt(0).toUpperCase() + field.slice(1).replace(/_/g, " ")}</td>
                            <td className="mytable" style={{ borderWidth: "1" }}>{userData[field] || "NA"}</td>
                          </tr>
                        )
                      ))}
                    </table>
                  </div>
                )}
              </div>


            </div>

            <div className="imagePreviewContainer-pan">
              {isVerified && previewData.front ? (
                <div style={{
                  border: "2px solid gray",
                  borderRadius: "15px",
                  padding: "10px",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                  maxWidth: "90%",
                  margin: "auto",
                }}>

                  <div style={{
                    justifyContent: "space-around",
                    alignItems: "center", // This centers items vertically
                    flexWrap: "wrap",
                    rowGap: "10px",
                  }}>
                    <img style={{ width: "15%", minWidth: "80px", objectFit: "contain" }} src={Lion} alt="logo" />
                    <h6>PAN CARD</h6>
                  </div>


                  <hr />

                  <div style={{
                    display: "flex",
                    padding: "5px",
                    flexDirection: "row",
                    gap: "20px",
                    alignItems: "center",
                    marginTop: "15px",
                    flexWrap: "nowrap",
                    width: "60%",
                    maxWidth: "600px",

                  }}>
                    <div style={{ textAlign: "left", minWidth: "100px" }}>
                      <h6>Name</h6>
                      <h6>Father Name</h6>
                      <h6>DOB</h6>
                      <h6>PAN Number</h6>
                    </div>
                    <div
                      style={{
                        textAlign: "left",
                        flex: "1",
                        display: "flex",
                        flexDirection: "column",
                        minWidth: "150px",
                        border: "5px soild red"
                      }}
                    >
                      <h6>   : {userData?.name || "N/A"}</h6>
                      <h6>   : {userData?.father_name || "N/A"}</h6>
                      <h6>   : {userData?.dob || "N/A"}</h6>
                      <h6>   : {userData?.pan_number || "N/A"}</h6>
                    </div>
                  </div>


                  {/* <hr/> */}

                  {/* <div style={{textAlign:"left", padding:"10px"}}>
                    <h6>Address:</h6>
                    <h6>Dalocal Technologies is D1-004, White House, Kedia Arcade Registered address of, Shivaji Nagar, Bangalore, Karnataka, India - 560032</h6>
                  </div> */}

                  <hr />

                  <div style={{
                    textAlign: "left",
                    padding: "20px",
                    display: "flex",
                    justifyContent: "space-evenly",
                    flexWrap: "wrap",
                    rowGap: "15px"
                  }}>
                    <img
                      style={{
                        width: "50%",
                        minWidth: "100px",
                        height: "auto",
                        objectFit: "contain"
                      }}
                      src={digi}
                      alt=" digilocker logo"
                    />
                    {/* <img
                      style={{
                        width: "30%",
                        minWidth: "100px",
                        height: "auto",
                        objectFit: "contain"
                      }}
                      src={"http://www.pngmart.com/files/10/Qr-Code-Transparent-PNG.png"}
                      alt="logo"
                    /> */}
                  </div>



                </div>

              ) : (
                <VerifyPANCardSkeleton2 />
              )}
              <FreehandCropper open={openRectCropper} onClose={handleRectCropperClose} onSave={(croppedFile) => handleSaveBgImage(croppedFile, currentSide)} file={selectedBgFile} selectedImage={selectedBgImage} />
            </div>

            <Modal open={close}>
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  backgroundColor: "white",
                  padding: "24px",
                  width: "800px",
                  maxHeight: "80vh",
                  overflowY: "auto",
                  borderRadius: "8px",
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                }}
              >
                {/* Header with Close Button */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "24px",
                  }}
                >
                  <div>
                    <h5
                      style={{
                        fontSize: "20px",
                        fontWeight: "600",
                        color: "#111827",
                        margin: "0 0 4px 0",
                      }}
                    >
                      Correct PAN Details
                    </h5>
                    <p
                      style={{
                        fontSize: "14px",
                        color: "#6B7280",
                        margin: "0",
                      }}
                    >
                      {getMismatchCount()} field(s) need correction to match Digilocker
                      <span
                        style={{
                          marginLeft: "8px",
                          fontSize: "12px",
                          color: "#DC2626",
                          fontWeight: "500",
                        }}
                      >
                        (PAN Number cannot be edited)
                      </span>
                    </p>
                  </div>
                  <IconButton
                    onClick={() => setClose(false)}
                    size="small"
                    style={{ color: "#6B7280" }}
                  >
                    <CloseRoundedIcon />
                  </IconButton>
                </div>

                {/* Fields Container */}
                <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                  {/* PAN Number Field - Non-editable */}
                  {(ocrResponse?.pan_number || GetData?.pan_number || Digilockerdata?.pan_number) && (
                    <div
                      style={{
                        border: "1px solid #E5E7EB",
                        borderRadius: "8px",
                        padding: "16px",
                      }}
                    >
                      <div>
                        <label
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#374151",
                            marginBottom: "8px",
                            display: "block",
                          }}
                        >
                          PAN Number
                        </label>

                        {/* Current OCR Value */}
                        {(ocrResponse?.pan_number || GetData?.pan_number) && (
                          <>
                            <div
                              style={{
                                fontSize: "12px",
                                color: "#6B7280",
                                marginBottom: "4px",
                              }}
                            >
                              Current (from OCR):
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "8px 12px",
                                backgroundColor: "#F9FAFB",
                                border: "1px solid #E5E7EB",
                                borderRadius: "6px",
                                marginBottom: "12px",
                              }}
                            >
                              <span style={{ color: "#374151", fontSize: "14px" }}>
                                {ocrResponse?.pan_number || GetData?.pan_number}
                              </span>
                            </div>
                          </>
                        )}

                        {/* Digilocker Value */}
                        {userData?.pan_number && (
                          <>
                            <div
                              style={{
                                fontSize: "12px",
                                color: "#6B7280",
                                marginBottom: "4px",
                              }}
                            >
                              From Digilocker:
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                padding: "8px 12px",
                                backgroundColor: "#F0FDF4",
                                border: "1px solid #86EFAC",
                                borderRadius: "6px",
                              }}
                            >
                              <span
                                style={{
                                  color: "#15803D",
                                  fontSize: "14px",
                                  fontWeight: "500",
                                }}
                              >
                                {userData?.pan_number}
                              </span>
                              {(ocrResponse?.pan_number === userData?.pan_number || GetData?.pan_number === userData?.pan_number) && (
                                <span
                                  style={{
                                    marginLeft: "8px",
                                    padding: "2px 8px",
                                    backgroundColor: "#86EFAC",
                                    color: "#166534",
                                    fontSize: "11px",
                                    fontWeight: "600",
                                    borderRadius: "12px",
                                    display: "inline-flex",
                                    alignItems: "center",
                                  }}
                                >
                                  ✓ Verified
                                </span>
                              )}
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Name Field */}
                  {(ocrResponse?.name || GetData?.name || Digilockerdata?.name) && (
                    <div
                      style={{
                        border: "1px solid #E5E7EB",
                        borderRadius: "8px",
                        padding: "16px",
                      }}
                    >
                      <div>
                        <label
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#374151",
                            marginBottom: "8px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          Name on PAN *
                          {formData.name && Digilockerdata?.name && formData.name !== Digilockerdata.name && (
                            <span
                              style={{
                                marginLeft: "8px",
                                padding: "2px 8px",
                                backgroundColor: "#FEE2E2",
                                color: "#B91C1C",
                                fontSize: "11px",
                                fontWeight: "600",
                                borderRadius: "12px",
                              }}
                            >
                              Needs correction
                            </span>
                          )}
                        </label>

                        {/* Current OCR Value - Only if mismatch exists */}
                        {(ocrResponse?.name || GetData?.name) && Digilockerdata?.name &&
                          (ocrResponse?.name || GetData?.name) !== Digilockerdata.name && (
                            <>
                              <div
                                style={{
                                  fontSize: "12px",
                                  color: "#6B7280",
                                  marginBottom: "4px",
                                }}
                              >
                                Current (from OCR):
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  padding: "8px 12px",
                                  backgroundColor: "#FEF2F2",
                                  border: "1px dashed #EF4444",
                                  borderRadius: "6px",
                                  marginBottom: "12px",
                                }}
                              >
                                <span
                                  style={{
                                    color: "#B91C1C",
                                    fontSize: "14px",
                                    textDecoration: "line-through",
                                  }}
                                >
                                  {ocrResponse?.name || GetData?.name}
                                </span>
                              </div>
                            </>
                          )}

                        {/* Correction Input - Only if mismatch exists */}
                        {Digilockerdata?.name &&
                          (ocrResponse?.name || GetData?.name) !== Digilockerdata.name && (
                            <>
                              <div style={{ marginBottom: "8px" }}>
                                <div
                                  style={{
                                    fontSize: "12px",
                                    color: "#6B7280",
                                    marginBottom: "4px",
                                  }}
                                >
                                  Correct to:
                                </div>
                                <input
                                  type="text"
                                  name="name"
                                  value={formData.name || ocrResponse?.name || GetData?.name || ""}
                                  onChange={handleChange}
                                  style={{
                                    width: "100%",
                                    padding: "8px 12px",
                                    border: "1px solid #93C5FD",
                                    borderRadius: "6px",
                                    fontSize: "14px",
                                    outline: "none",
                                  }}
                                  onFocus={(e) => (e.target.style.borderColor = "#3B82F6")}
                                  onBlur={(e) => (e.target.style.borderColor = "#93C5FD")}
                                  placeholder="Enter correct Name"
                                />
                              </div>

                              {/* Suggestion from Digilocker */}
                              <div>
                                <div
                                  style={{
                                    fontSize: "12px",
                                    color: "#6B7280",
                                    marginBottom: "4px",
                                  }}
                                >
                                  Suggested (from Digilocker):
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    padding: "8px 12px",
                                    backgroundColor: "#F0FDF4",
                                    border: "1px solid #86EFAC",
                                    borderRadius: "6px",
                                  }}
                                >
                                  <span
                                    style={{
                                      color: "#15803D",
                                      fontSize: "14px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {Digilockerdata.name}
                                  </span>
                                  <button
                                    onClick={() =>
                                      handleChange({
                                        target: { name: "name", value: Digilockerdata.name },
                                      })
                                    }
                                    style={{
                                      padding: "4px 12px",
                                      backgroundColor: "#16A34A",
                                      color: "white",
                                      fontSize: "12px",
                                      fontWeight: "500",
                                      border: "none",
                                      borderRadius: "4px",
                                      cursor: "pointer",
                                    }}
                                    onMouseEnter={(e) =>
                                      (e.target.style.backgroundColor = "#15803D")
                                    }
                                    onMouseLeave={(e) =>
                                      (e.target.style.backgroundColor = "#16A34A")
                                    }
                                  >
                                    Use This
                                  </button>
                                </div>
                              </div>
                            </>
                          )}

                        {/* Already Verified Message */}
                        {Digilockerdata?.name &&
                          (ocrResponse?.name || GetData?.name) === Digilockerdata.name && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "8px 12px",
                                backgroundColor: "#F0FDF4",
                                border: "1px solid #86EFAC",
                                borderRadius: "6px",
                              }}
                            >
                              <span
                                style={{
                                  color: "#15803D",
                                  fontSize: "14px",
                                  fontWeight: "500",
                                }}
                              >
                                ✓ Verified: {Digilockerdata.name}
                              </span>
                            </div>
                          )}
                      </div>
                    </div>
                  )}

                  {/* Date of Birth Field */}
                  {(ocrResponse?.dob || GetData?.dob || Digilockerdata?.dob) && (
                    <div
                      style={{
                        border: "1px solid #E5E7EB",
                        borderRadius: "8px",
                        padding: "16px",
                      }}
                    >
                      <div>
                        <label
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#374151",
                            marginBottom: "8px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          Date of Birth *
                          {formData.dob && Digilockerdata?.dob && formData.dob !== Digilockerdata.dob && (
                            <span
                              style={{
                                marginLeft: "8px",
                                padding: "2px 8px",
                                backgroundColor: "#FEE2E2",
                                color: "#B91C1C",
                                fontSize: "11px",
                                fontWeight: "600",
                                borderRadius: "12px",
                              }}
                            >
                              Needs correction
                            </span>
                          )}
                        </label>

                        {/* Current OCR Value - Only if mismatch exists */}
                        {(ocrResponse?.dob || GetData?.dob) && Digilockerdata?.dob &&
                          (ocrResponse?.dob || GetData?.dob) !== Digilockerdata.dob && (
                            <>
                              <div
                                style={{
                                  fontSize: "12px",
                                  color: "#6B7280",
                                  marginBottom: "4px",
                                }}
                              >
                                Current (from OCR):
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  padding: "8px 12px",
                                  backgroundColor: "#FEF2F2",
                                  border: "1px dashed #EF4444",
                                  borderRadius: "6px",
                                  marginBottom: "12px",
                                }}
                              >
                                <span
                                  style={{
                                    color: "#B91C1C",
                                    fontSize: "14px",
                                    textDecoration: "line-through",
                                  }}
                                >
                                  {ocrResponse?.dob || GetData?.dob}
                                </span>
                              </div>
                            </>
                          )}

                        {/* Correction Input - Only if mismatch exists */}
                        {Digilockerdata?.dob &&
                          (ocrResponse?.dob || GetData?.dob) !== Digilockerdata.dob && (
                            <>
                              <div style={{ marginBottom: "8px" }}>
                                <div
                                  style={{
                                    fontSize: "12px",
                                    color: "#6B7280",
                                    marginBottom: "4px",
                                  }}
                                >
                                  Correct to:
                                </div>
                                <input
                                  type="text"
                                  name="dob"
                                  value={formData.dob || ocrResponse?.dob || GetData?.dob || ""}
                                  onChange={handleChange}
                                  style={{
                                    width: "100%",
                                    padding: "8px 12px",
                                    border: "1px solid #93C5FD",
                                    borderRadius: "6px",
                                    fontSize: "14px",
                                    outline: "none",
                                  }}
                                  onFocus={(e) => (e.target.style.borderColor = "#3B82F6")}
                                  onBlur={(e) => (e.target.style.borderColor = "#93C5FD")}
                                  placeholder="Enter correct Date of Birth"
                                />
                              </div>

                              {/* Suggestion from Digilocker */}
                              <div>
                                <div
                                  style={{
                                    fontSize: "12px",
                                    color: "#6B7280",
                                    marginBottom: "4px",
                                  }}
                                >
                                  Suggested (from Digilocker):
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    padding: "8px 12px",
                                    backgroundColor: "#F0FDF4",
                                    border: "1px solid #86EFAC",
                                    borderRadius: "6px",
                                  }}
                                >
                                  <span
                                    style={{
                                      color: "#15803D",
                                      fontSize: "14px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {Digilockerdata.dob}
                                  </span>
                                  <button
                                    onClick={() =>
                                      handleChange({
                                        target: { name: "dob", value: Digilockerdata.dob },
                                      })
                                    }
                                    style={{
                                      padding: "4px 12px",
                                      backgroundColor: "#16A34A",
                                      color: "white",
                                      fontSize: "12px",
                                      fontWeight: "500",
                                      border: "none",
                                      borderRadius: "4px",
                                      cursor: "pointer",
                                    }}
                                    onMouseEnter={(e) =>
                                      (e.target.style.backgroundColor = "#15803D")
                                    }
                                    onMouseLeave={(e) =>
                                      (e.target.style.backgroundColor = "#16A34A")
                                    }
                                  >
                                    Use This
                                  </button>
                                </div>
                              </div>
                            </>
                          )}

                        {/* Already Verified Message */}
                        {Digilockerdata?.dob &&
                          (ocrResponse?.dob || GetData?.dob) === Digilockerdata.dob && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "8px 12px",
                                backgroundColor: "#F0FDF4",
                                border: "1px solid #86EFAC",
                                borderRadius: "6px",
                              }}
                            >
                              <span
                                style={{
                                  color: "#15803D",
                                  fontSize: "14px",
                                  fontWeight: "500",
                                }}
                              >
                                ✓ Verified: {Digilockerdata.dob}
                              </span>
                            </div>
                          )}
                      </div>
                    </div>
                  )}



                  {/* Gender Field */}
                  {(ocrResponse?.gender || GetData?.gender || Digilockerdata?.gender) && (
                    <div
                      style={{
                        border: "1px solid #E5E7EB",
                        borderRadius: "8px",
                        padding: "16px",
                      }}
                    >
                      <div>
                        <label
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#374151",
                            marginBottom: "8px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          Gender *
                          {formData.gender && Digilockerdata?.gender &&
                            formData.gender !== Digilockerdata.gender && (
                              <span
                                style={{
                                  marginLeft: "8px",
                                  padding: "2px 8px",
                                  backgroundColor: "#FEE2E2",
                                  color: "#B91C1C",
                                  fontSize: "11px",
                                  fontWeight: "600",
                                  borderRadius: "12px",
                                }}
                              >
                                Needs correction
                              </span>
                            )}
                        </label>

                        {/* Current OCR Value - Only if mismatch exists */}
                        {(ocrResponse?.gender || GetData?.gender) &&
                          Digilockerdata?.gender &&
                          formatGender(ocrResponse?.gender || GetData?.gender) !== Digilockerdata.gender && (
                            <>
                              <div
                                style={{
                                  fontSize: "12px",
                                  color: "#6B7280",
                                  marginBottom: "4px",
                                }}
                              >
                                Current (from OCR):
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  padding: "8px 12px",
                                  backgroundColor: "#FEF2F2",
                                  border: "1px dashed #EF4444",
                                  borderRadius: "6px",
                                  marginBottom: "12px",
                                }}
                              >
                                <span
                                  style={{
                                    color: "#B91C1C",
                                    fontSize: "14px",
                                    textDecoration: "line-through",
                                  }}
                                >
                                  {formatGender(ocrResponse?.gender || GetData?.gender)}
                                </span>
                              </div>
                            </>
                          )}

                        {/* Correction Input - Only if mismatch exists */}
                        {Digilockerdata?.gender &&
                          formatGender(ocrResponse?.gender || GetData?.gender) !== Digilockerdata.gender && (
                            <>
                              <div style={{ marginBottom: "8px" }}>
                                <div
                                  style={{
                                    fontSize: "12px",
                                    color: "#6B7280",
                                    marginBottom: "4px",
                                  }}
                                >
                                  Correct to:
                                </div>
                                <input
                                  type="text"
                                  name="gender"
                                  value={formData.gender || formatGender(ocrResponse?.gender || GetData?.gender) || ""}
                                  onChange={handleChange}
                                  style={{
                                    width: "100%",
                                    padding: "8px 12px",
                                    border: "1px solid #93C5FD",
                                    borderRadius: "6px",
                                    fontSize: "14px",
                                    outline: "none",
                                  }}
                                  onFocus={(e) => (e.target.style.borderColor = "#3B82F6")}
                                  onBlur={(e) => (e.target.style.borderColor = "#93C5FD")}
                                  placeholder="Enter correct Gender"
                                />
                              </div>

                              {/* Suggestion from Digilocker */}
                              <div>
                                <div
                                  style={{
                                    fontSize: "12px",
                                    color: "#6B7280",
                                    marginBottom: "4px",
                                  }}
                                >
                                  Suggested (from Digilocker):
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    padding: "8px 12px",
                                    backgroundColor: "#F0FDF4",
                                    border: "1px solid #86EFAC",
                                    borderRadius: "6px",
                                  }}
                                >
                                  <span
                                    style={{
                                      color: "#15803D",
                                      fontSize: "14px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    {Digilockerdata.gender}
                                  </span>
                                  <button
                                    onClick={() =>
                                      handleChange({
                                        target: { name: "gender", value: Digilockerdata.gender },
                                      })
                                    }
                                    style={{
                                      padding: "4px 12px",
                                      backgroundColor: "#16A34A",
                                      color: "white",
                                      fontSize: "12px",
                                      fontWeight: "500",
                                      border: "none",
                                      borderRadius: "4px",
                                      cursor: "pointer",
                                    }}
                                    onMouseEnter={(e) =>
                                      (e.target.style.backgroundColor = "#15803D")
                                    }
                                    onMouseLeave={(e) =>
                                      (e.target.style.backgroundColor = "#16A34A")
                                    }
                                  >
                                    Use This
                                  </button>
                                </div>
                              </div>
                            </>
                          )}

                        {/* Already Verified Message */}
                        {Digilockerdata?.gender &&
                          formatGender(ocrResponse?.gender || GetData?.gender) === Digilockerdata.gender && (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "8px 12px",
                                backgroundColor: "#F0FDF4",
                                border: "1px solid #86EFAC",
                                borderRadius: "6px",
                              }}
                            >
                              <span
                                style={{
                                  color: "#15803D",
                                  fontSize: "14px",
                                  fontWeight: "500",
                                }}
                              >
                                ✓ Verified: {Digilockerdata.gender}
                              </span>
                            </div>
                          )}
                      </div>
                    </div>
                  )}
                </div>

                {/* No Data Message */}
                {!hasAnyData() && (
                  <div style={{ textAlign: "center", padding: "32px 0" }}>
                    <div style={{ fontSize: "48px", color: "#9CA3AF", marginBottom: "16px" }}>
                      📄
                    </div>
                    <h3
                      style={{
                        fontSize: "18px",
                        fontWeight: "600",
                        color: "#111827",
                        marginBottom: "8px",
                      }}
                    >
                      No Data Available
                    </h3>
                    <p style={{ fontSize: "14px", color: "#6B7280", margin: "0" }}>
                      No PAN data found from OCR or Digilocker.
                    </p>
                  </div>
                )}

                {/* Footer */}
                {hasAnyData() && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginTop: "32px",
                      paddingTop: "24px",
                      borderTop: "1px solid #E5E7EB",
                    }}
                  >
                    <div style={{ fontSize: "14px", color: "#6B7280" }}>
                      {getMismatchCount() > 0 && (
                        <span style={{ color: "#DC2626", fontWeight: "500" }}>
                          Please correct the field(s) above
                        </span>
                      )}
                    </div>

                    <div style={{ display: "flex" }}>
                      <button
                        onClick={() => setClose(false)}
                        style={{
                          padding: "8px 24px",
                          color: "#2563EB",
                          fontWeight: "500",
                          fontSize: "14px",
                          background: "none",
                          border: "none",
                          cursor: "pointer",
                          marginRight: "16px",
                        }}
                        onMouseEnter={(e) => (e.target.style.color = "#1D4ED8")}
                        onMouseLeave={(e) => (e.target.style.color = "#2563EB")}
                      >
                        CANCEL
                      </button>

                      {GetData !== "Not verified Yet" && GetData !== null && GetData !== undefined ? (
                        <button
                          style={{
                            padding: "8px 24px",
                            backgroundColor: "#16A34A",
                            color: "white",
                            fontWeight: "500",
                            fontSize: "14px",
                            borderRadius: "8px",
                            border: "none",
                            opacity: "0.7",
                            cursor: "not-allowed",
                          }}
                          disabled
                        >
                          VERIFIED
                        </button>
                      ) : (
                        <button
                          onClick={() => handleupdate()}
                          disabled={getMismatchCount() !== 0}
                          style={{
                            padding: "8px 24px",
                            backgroundColor: getMismatchCount() === 0 ? "#2563EB" : "#a3bdf5",
                            color: "white",
                            fontWeight: "500",
                            fontSize: "14px",
                            borderRadius: "8px",
                            border: "none",
                            cursor: getMismatchCount() === 0 ? "pointer" : "not-allowed",
                            opacity: getMismatchCount() === 0 ? "1" : "0.6",
                          }}
                          onMouseEnter={(e) => {
                            if (getMismatchCount() === 0) {
                              e.target.style.backgroundColor = "#1D4ED8";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (getMismatchCount() === 0) {
                              e.target.style.backgroundColor = "#2563EB";
                            }
                          }}
                        >
                          SAVE CORRECTIONS
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </Modal>
          </div>
        </div>
      </div>
    </div >
  );
};

export default VerifyPANCard;
